import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { Svg } from 'ui'

export default function UseCaseItem({
  svg,
  title,
  description,
}: {
  svg?: React.ElementType
  title?: string
  description: string | ReactElement
}): ReactElement {
  return (
    <Flex
      sx={{ width: '100%', maxWidth: ['100%', '102.2rem'], gap: '0.4rem', flexDirection: 'column' }}
    >
      <Flex
        sx={{
          gap: '0.8rem',
          flexDirection: ['column', 'row'],
          alignItems: ['flex-start', 'center'],
        }}
      >
        {svg && <Svg svg={svg} descriptiveText="use case icon" />}
        {title && (
          <Text variant="size15Weight600Line138Letter03" sx={{ color: 'aliceBlue' }}>
            {title}
          </Text>
        )}
      </Flex>
      <Text variant="size15Weight400Line138Letter03" sx={{ color: 'lightSteelBlue' }}>
        {description}
      </Text>
    </Flex>
  )
}
